export default __webpack_public_path__ + "static/media/logo.440061eb.png";